import { saleDetailsVisibilityColumns } from '@invoices/components/SaleDetailsDataSet/visibilityColumns';

import { type DataSetConfig } from '../types';

const initialSalesConfig: DataSetConfig = {
  sorting: [],
  pagination: { pageSize: 20, pageIndex: 0 },
  columnsVisibility: saleDetailsVisibilityColumns,
};

export { initialSalesConfig };
